
define('ldsh!modules/editor/templates/editors/seo_custom_meta', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-form-group">\n  <label style="position:relative;">\n    <span data-i18n="editor.seo.customMeta"></span>\n  </label>\n  <div class="ed-choices-list js-meta-fields"></div>\n  <div class="ed-choices-list-actions">\n    <button class="btn--link js-add-meta-field f18">\n      <i class="ri-add-line"></i>\n    </button>\n  </div>\n</div>\n';

}
return __p
};});

